var _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 184,
    viewBox: "0 0 196 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 152.5,
    r: 2.5,
    fill: "#DEE1E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 152.5,
    r: 2.5,
    fill: "#DEE1E6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 152.5,
    r: 2.5,
    fill: "#DEE1E6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 0.5,
    width: 108,
    height: 183,
    rx: 11.5,
    stroke: "#212429"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 26,
    width: 70,
    height: 111,
    rx: 4,
    fill: "#52A0F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 37,
    width: 56,
    height: 52,
    rx: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 94,
    width: 38,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 94,
    width: 9,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 102,
    width: 15,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 112,
    width: 25,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 112,
    width: 7,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 112,
    width: 9,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 120,
    width: 19,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 120,
    width: 14,
    height: 5,
    rx: 1,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 102,
    width: 35,
    height: 5,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.729 81.6252C106.259 81.6252 107.5 80.3846 107.5 78.8543C107.5 77.324 106.259 76.0835 104.729 76.0835C103.199 76.0835 101.958 77.324 101.958 78.8543C101.958 80.3846 103.199 81.6252 104.729 81.6252Z",
    fill: "#353A40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0628 81.6252C93.5931 81.6252 94.8337 80.3846 94.8337 78.8543C94.8337 77.324 93.5931 76.0835 92.0628 76.0835C90.5325 76.0835 89.292 77.324 89.292 78.8543C89.292 80.3846 90.5325 81.6252 92.0628 81.6252Z",
    fill: "#353A40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6637 52.2382L86.347 56.1173C86.2837 56.8615 86.8695 57.479 87.6137 57.479H111.854C112.519 57.479 113.074 56.9723 113.121 56.3073C113.327 53.5048 111.189 51.2248 108.387 51.2248H88.9278C88.7695 50.5282 88.4528 49.8632 87.962 49.309C87.1703 48.4698 86.062 47.979 84.922 47.979H82.167C81.5178 47.979 80.9795 48.5173 80.9795 49.1665C80.9795 49.8157 81.5178 50.354 82.167 50.354H84.922C85.4128 50.354 85.872 50.5598 86.2045 50.9082C86.537 51.2723 86.6953 51.7473 86.6637 52.2382Z",
    fill: "#353A40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.474 59.854H87.1856C86.5206 59.854 85.9823 60.3607 85.9189 61.0098L85.3489 67.8973C85.1273 70.6048 87.2489 72.9165 89.9564 72.9165H107.563C109.938 72.9165 112.028 70.969 112.202 68.594L112.725 61.1998C112.788 60.4715 112.218 59.854 111.474 59.854Z",
    fill: "#353A40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.947 129.638C178.429 128.452 179.054 127.497 179.823 126.773C180.592 126.049 181.315 125.544 181.992 125.258C182.67 124.972 183.775 124.536 185.308 123.95C185.465 123.883 186.119 123.653 187.273 123.258C188.426 122.863 189.428 122.255 190.28 121.435C191.168 120.63 191.845 119.653 192.312 118.505C193.094 116.577 193.082 114.694 192.275 112.855C191.519 110.994 190.178 109.673 188.251 108.89C186.324 108.107 184.396 108.123 182.468 108.938C180.592 109.73 179.255 111.108 178.457 113.072L177.645 115.074L175.022 113.879L175.789 111.989C176.496 110.247 177.57 108.826 179.009 107.727C180.449 106.628 182.075 105.972 183.889 105.759C185.717 105.508 187.521 105.744 189.3 106.467C191.079 107.189 192.525 108.251 193.64 109.654C194.769 111.019 195.455 112.571 195.699 114.311C195.942 116.05 195.717 117.772 195.025 119.477C194.438 120.922 193.712 122.074 192.845 122.931C191.994 123.751 191.17 124.344 190.374 124.712C189.614 125.094 188.52 125.556 187.091 126.098C186.83 126.208 186.142 126.468 185.025 126.878C183.924 127.251 182.986 127.755 182.21 128.39C181.471 129.04 180.906 129.846 180.515 130.81L179.408 133.534L176.796 132.473L177.947 129.638ZM173.253 138.805C173.508 138.175 173.941 137.747 174.552 137.519C175.177 137.255 175.805 137.251 176.435 137.507C177.065 137.763 177.493 138.196 177.72 138.806C178 139.395 178.011 140.004 177.755 140.634C177.5 141.264 177.059 141.711 176.434 141.975C175.808 142.239 175.199 142.251 174.606 142.01C173.976 141.754 173.529 141.313 173.265 140.688C173.001 140.063 172.997 139.435 173.253 138.805Z",
    fill: "#212429"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3042 53.7109C16.6234 52.627 16.2139 51.5616 16.0759 50.5146C15.9378 49.4676 15.9506 48.5857 16.1144 47.8687C16.2781 47.1518 16.5702 46 16.9906 44.4133C17.0284 44.2478 17.224 43.5817 17.5775 42.4149C17.931 41.2481 18.0238 40.0798 17.8558 38.9099C17.7216 37.7188 17.3248 36.5982 16.6652 35.5482C15.5588 33.7868 14.0235 32.6964 12.0595 32.2769C10.108 31.8022 8.25158 32.118 6.49025 33.2244C4.72892 34.3308 3.61525 35.9043 3.14924 37.9448C2.69583 39.9301 3.03296 41.8204 4.16063 43.6156L5.30958 45.4447L2.80699 46.875L1.72187 45.1475C0.721852 43.5556 0.196471 41.8544 0.145722 40.044C0.0949724 38.2337 0.512986 36.5303 1.39976 34.9341C2.26526 33.304 3.51094 31.9783 5.13678 30.957C6.76262 29.9357 8.47009 29.3827 10.2592 29.2981C12.027 29.1796 13.6877 29.5299 15.2414 30.3489C16.7951 31.1679 18.0614 32.3565 19.0401 33.9146C19.8699 35.2356 20.3794 36.498 20.5687 37.7017C20.7368 38.8716 20.7369 39.887 20.5693 40.7481C20.4355 41.588 20.171 42.7461 19.7758 44.2225C19.7128 44.4982 19.5215 45.2089 19.2019 46.3544C18.861 47.4661 18.7213 48.5221 18.783 49.5226C18.8785 50.5019 19.2028 51.4318 19.756 52.3125L21.3199 54.802L18.9319 56.3021L17.3042 53.7109ZM21.9996 62.8777C21.6379 62.3019 21.5433 61.7 21.7157 61.0721C21.8668 60.4103 22.2303 59.8986 22.8061 59.5369C23.382 59.1752 23.9838 59.0805 24.6117 59.2529C25.2522 59.3702 25.7534 59.7167 26.1151 60.2926C26.4768 60.8684 26.5821 61.4872 26.4309 62.149C26.2798 62.8108 25.9332 63.3119 25.3913 63.6523C24.8155 64.014 24.1967 64.1193 23.5349 63.9681C22.8731 63.817 22.3614 63.4535 21.9996 62.8777Z",
    fill: "#212429"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrder);
export default __webpack_public_path__ + "static/media/empty-order.19ea820aee60f4b773f94ac87de4c429.svg";
export { ForwardRef as ReactComponent };